$(document).ready(function () {
    if ($('#cd-timeline').length) {
        timeline();
    }

    if ($('.multiple-timelines').length) {
        $('.timeline-index-1').show();
        $('#timeline-index-1').addClass('current');

        changeTimeline();
    }
});

function timeline() {
    console.log('Ran timeline()');
    cd_timeline_img_top_adjust();
    $('body').addClass('cssanimations');

    var timelineBlocks = $('.cd-timeline-block');
    var offset = 1;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function() {
        (!window.requestAnimationFrame) ?
            setTimeout(function() {
                showBlocks(timelineBlocks, offset);
            }, 100):
            window.requestAnimationFrame(function() {
                showBlocks(timelineBlocks, offset);
            });
    });

    function hideBlocks(blocks, offset) {
        blocks.each(function() {
            if ($(this).offset().top > $(window).scrollTop() + $(window).height() * offset) {
                $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
                $(this).find('.cd-year-line').removeClass('bounce-in');
            }
        });
    }

    function showBlocks(blocks, offset) {
        blocks.each(function() {
            if ($(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden')) {
                $(this).find('.cd-timeline-img, .cd-timeline-content, .cd-year-line')
                    .removeClass('is-hidden')
                    .addClass('bounce-in');
            }
        });

        $('.cd-year-line').each(function() {
            var year_height = $(this).parent().find('h2').position().top;
            var yearline_width = $('.cd-timeline').innerWidth() / 4;

            $(this).css('width', yearline_width - 20);
            $(this).css('top', year_height + 11);

            if ($(this).hasClass('right')) {
                $(this).css('right', yearline_width + 20);
            } else {
                $(this).css('right', yearline_width * 2);
            }
        });

        $('.cd-timeline-img').each(function() {
            var year_height = $(this).parent().find('h2').position().top;
            $(this).css('top', year_height + 6);
        });
    }

    $(window).on('resize', function() {
        cd_timeline_img_top_adjust();
    });

}

function cd_timeline_img_top_adjust() {
    setTimeout(function() {
        var yearline_width = $('.cd-container:visible').innerWidth() / 4;

        $('.cd-year-line').each(function() {
            var year_height = $(this).parent().find('h2').position().top;
            console.log('=============================');
            console.log(yearline_width);
            var $this = $(this);


            $this.css('width', yearline_width - 20);
            $this.css('top', year_height + 11);

            // setTimeout(function(){
            // 	$this.addClass('active');
            // }, 500);

            if ($this.hasClass('right')) {
                $this.css('right', yearline_width + 20);
            } else {
                $this.css('right', yearline_width * 2);
            }
        });

        $('.cd-timeline-img').each(function() {
            var year_height = $(this).parent().find('h2').position().top;
            $(this).css('top', year_height + 6);
        });
    }, 100);
}

// ===
// Code for multiple timeline module
// ===

function changeTimeline() {
    $('.timeline-change-buttons').on('click', (e) => {
        // If user clicked current timeline button dont do anything
        if (e.target.classList.contains('current'))
            return;

        // Remove current class
        $('.timeline-change-buttons.current').removeClass('current');

        // Add current class to clicked button
        e.target.classList.toggle('current');

        let timeline = e.target.attributes.id.nodeValue;

        $('.multiple-timeline-entry').fadeOut(200);
        setTimeout(() => {
            $('.' + timeline).fadeIn(200);
        }, 200);

        setTimeout(() => {
            cd_timeline_img_top_adjust();
        }, 500);

    });
}
